<template>
  <!-- 블록 디스패처 — message.block.type 에 맞는 컴포넌트로 렌더.
       draft_confirm/consultation_draft 은 HITL 상태/이벤트를 추가 전달, 그 외는 data 만.
       미지원 타입은 폴백. -->
  <draft-confirm-block
    v-if="type === 'draft_confirm'"
    :data="block.data || {}"
    :committing="!!message.committing"
    :done="!!message.done"
    @commit="$emit('commit', $event)"
    @cancel="$emit('cancel')"
    @refine="$emit('refine', $event)"
  />
  <consultation-draft-block
    v-else-if="type === 'consultation_draft'"
    :data="block.data || {}"
    :committing="!!message.committing"
    :done="!!message.done"
    @commit="$emit('commit', $event)"
    @cancel="$emit('cancel')"
    @refine="$emit('refine', $event)"
  />
  <admin-action-draft-block
    v-else-if="type === 'admin_draft'"
    :data="block.data || {}"
    :committing="!!message.committing"
    :done="!!message.done"
    @commit="$emit('commit', $event)"
    @cancel="$emit('cancel')"
    @refine="$emit('refine', $event)"
  />
  <component :is="resolved" v-else :data="resolvedData" />
</template>

<script>
import TextBlock from './blocks/TextBlock.vue'
import TableBlock from './blocks/TableBlock.vue'
import ChartBlock from './blocks/ChartBlock.vue'
import CardBlock from './blocks/CardBlock.vue'
import LinkBlock from './blocks/LinkBlock.vue'
import DraftConfirmBlock from './blocks/DraftConfirmBlock.vue'
import ConsultationDraftBlock from './blocks/ConsultationDraftBlock.vue'
import AdminActionDraftBlock from './blocks/AdminActionDraftBlock.vue'
import ReplyDraftBlock from './blocks/ReplyDraftBlock.vue'
import i18n from '@/locales/i18n'

// draft_confirm/consultation_draft/admin_draft은 template의 v-if/v-else-if에서 직접 처리(상태/이벤트 전달)
// 하므로 MAP에 포함하지 않는다.
const MAP = {
  text: TextBlock,
  table: TableBlock,
  chart: ChartBlock,
  card: CardBlock,
  link: LinkBlock,
  reply_draft: ReplyDraftBlock
}

/**
 * @component BlockRenderer
 * @description message.block({type,data})을 타입별 블록 컴포넌트로 분기 렌더.
 *   DisambiguateBlock 등 미지원/폐기 타입은 안내 텍스트로 안전 폴백(throw 없음).
 */
export default {
  name: 'BlockRenderer',
  components: { TextBlock, TableBlock, ChartBlock, CardBlock, LinkBlock, DraftConfirmBlock, ConsultationDraftBlock, AdminActionDraftBlock, ReplyDraftBlock },
  inheritAttrs: false, // 다중 루트(v-if/v-else) — fallthrough attr 경고 방지
  props: {
    message: { type: Object, required: true }
  },
  emits: ['commit', 'cancel', 'refine'],
  computed: {
    block() { return this.message.block || {} },
    type() { return this.block.type },
    isKnown() { return Object.prototype.hasOwnProperty.call(MAP, this.type) },
    resolved() { return this.isKnown ? MAP[this.type] : TextBlock },
    resolvedData() {
      return this.isKnown ? (this.block.data || {}) : { markdown: i18n.global.t('assistant.unsupportedBlock') }
    }
  }
}
</script>
